import { render, staticRenderFns } from "./HMSurveyQuestion.vue?vue&type=template&id=772242ca&scoped=true&"
import script from "./HMSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./HMSurveyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772242ca",
  null
  
)

export default component.exports